<template>
  <div class="NewsCenterDetails" style="align-self: center;">
    <!-- 标题 -->
    <div class="flex-all-center mt-76">
      <p class="titletext">{{ $t('newsCenterDetails4.text1') }}</p>
    </div>
        <!-- 标题下图标 -->
    <div class="timeandaddress flex-all-center">
        <div class="mr-6"><img src="../../assets/images/time_icon.png" class="iconimg "></div>
        <div class="mr-38">{{ $t('newsCenterDetails4.text2') }}</div>
        <div class="mr-6"><img src="../../assets/images/postion_icon.png" class="iconimg"></div>
        <div>{{ $t('newsCenterDetails4.text3') }}</div>
    </div>
        <!-- 正文 -->
    <div class="main">
      <div class="maincontent">
        <div class="textlayout">
          <img src="../../assets/images/NewsCenterDetails4_pic1.png" class="picimg1">
        </div>
          
        <div class="textlayout">
          <p>{{ $t('newsCenterDetails4.text4') }}</p>
        </div>
          
        <p class="maintitie">{{ $t('newsCenterDetails4.text5') }}</p>

        <div class="textlayout"> 
          <img src="../../assets/images/NewsCenterDetails4_pic2.png" class="picimg2">
          <img src="../../assets/images/NewsCenterDetails4_pic3.png" class="picimg2">
        </div>

        <div class="textlayout mt-20">
          <img src="../../assets/images/NewsCenterDetails4_pic4.png" class="picimg3">
          <img src="../../assets/images/NewsCenterDetails4_pic5.png" class="picimg3">
          <img src="../../assets/images/NewsCenterDetails4_pic6.png" class="picimg3">
        </div>

        <p>{{ $t('newsCenterDetails4.text6') }}</p>

        <p>{{ $t('newsCenterDetails4.text7') }}</p>
        
        <div class="textlayout">
          <img src="../../assets/images/NewsCenterDetails4_pic7.png" class="picimg4">
          <img src="../../assets/images/NewsCenterDetails4_pic8.png" class="picimg4">
        </div>

          <div class="maintitie">{{ $t('newsCenterDetails4.text9') }}</div>
          
          <p>{{ $t('newsCenterDetails4.text10') }}</p>

          <p>{{ $t('newsCenterDetails4.text11') }}</p>

          <div class="textlayout">
          <video id="playerId" class="video-js vjs-default-skin video"
          controls preload="none" 
          poster="../../assets/images/NewsCenterDetails4_pic7.png"
          data-setup="{}">
          <source src="https://static-dev.aicarb.com/blacklocustcap/videos/%E4%B8%8A%E6%B5%B7%E5%BC%80%E4%B8%9A%E8%A7%86%E9%A2%91.mp4" type='video/mp4' />
          </video>
            </div>


      </div>
    </div>

    <div class="footer"></div>
</div>
</template>

<script>
import 'video.js/dist/video-js.css';

export default {
  name: "NewsCenterDetails4",
  components: {
    // Tabbar,
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {},
  methods: {},

};
</script>

<style lang="scss" scoped>
.NewsCenterDetails
{
    color: #000;
    width: 100%;
}

.titletext
{
  font-family: "OPPO-B";
  max-width: 990px;
  line-height: 60px;
  font-size: 42px;
  text-align: center;
}
.main
{
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.textlayout
{
  display: flex;
  align-items: center;
  justify-content: center;
}

.maincontent
{
  max-width: 990px;
   text-indent: 32px;
   text-align:justify;
   width: 100%;
   line-height: 32px;
   p{
    font-family:"OPPO-R";
    font-size: 16px;
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
    margin-bottom: 40px;
   }
}

.timeandaddress
{
    color: #909399;
    margin-top: 37px;
    font-family: "OPPO-R";
    font-size: 1rem;
}

.iconimg
{
    width: 17px;
    height: auto;
    position:relative;
    top: 2px;
}
.picimg1
{
    width: 890px;
    height: auto;
    margin-top: 40px;
    margin-bottom: 40px;
}
.picimg2
{
    width: 435px;
    height: auto;
    margin-left: 20px;


}
.picimg3
{
    width: 284px;
    height: auto;
    margin-left: 20px;
    margin-top: 0px;
    margin-bottom: 40px;
}
.picimg4
{
    width: 435px;
    height: auto;
    margin-left: 20px;
    margin-top: 40px;

}
.footer
{
  margin-top: 120px;
}
.video
{
  width: 890px;
  height:auto;
  margin-top: 40px;
}
@media (max-width: 768px) {
  .titletext
{
  width: 90%;
}
.textlayout
{
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.maincontent
{
   text-indent: 32px;
   font-family: "OPPO-R";
   font-size: 17px;
   line-height: 32px;
   width: 90%;

   p{
    font-family:"OPPO-R";
    font-size: 16px;
    
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
   }
}

.picimg1
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-left: 0px;
}
.picimg2
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-left: 0px;
}
.picimg3
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-left: 0px;
}
.picimg4
{
    width: 90%;
    height: auto;
    margin-top: 29px;
    margin-left: 0px;
}

.footer
{
  margin-top: 40px;
}
.video
{
  width: 90%;
  height: auto;
  margin-top: 40px;
  margin-left: 0px;
}
}
</style>